// Typelizer digest ba8b40e44578899fcbedec3adb382ad7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/questions/:question_id/resolution */
  create: (
    params: { questionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/questions/:question_id/resolution', params, options),
    method: 'post',
  }),
}
